// extracted by mini-css-extract-plugin
module.exports = {"title":"TopBar_title__1_zdj","container":"TopBar_container__10f14","backButton":"TopBar_backButton__1ZAzw"};